module.exports = __webpack_public_path__ + "static/FullSizeRender-6a0183351c3a07b6a4953465332e78a3.jpeg";